import { render } from "./OkConfirm.vue?vue&type=template&id=01b71544"
import script from "./OkConfirm.vue?vue&type=script&lang=js"
export * from "./OkConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__